var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailblocking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 316,
    viewBox: "0 0 384 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_27318)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 316,
    rx: 16,
    fill: "#A41E18"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.62 13.0902L53.4823 70.7361C48.6748 72.0242 45.8163 76.9449 47.0976 81.7268L98.6977 313.056C99.979 317.838 104.915 320.67 109.722 319.382L320.455 262.916C325.263 261.628 328.121 256.707 326.84 251.925L279.644 19.4161C278.363 14.6342 273.427 11.802 268.62 13.0902Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.62 13.0898L53.483 70.7357C48.6755 72.0239 45.817 76.9446 47.0983 81.7265L104.769 296.956C106.05 301.738 110.986 304.571 115.794 303.282L330.931 245.636C335.738 244.348 338.597 239.428 337.316 234.646L279.645 19.4158C278.364 14.6339 273.428 11.8017 268.62 13.0898Z",
    fill: "#FFFAF0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_871_27318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_871_27318",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 1,
    width: 313,
    height: 310
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.653 1.4616L46.7302 63.8939C42.4183 65.0496 39.8653 69.4787 41.0279 73.7865L103.372 304.79C104.535 309.097 108.973 311.653 113.285 310.497L346.208 248.064C350.52 246.909 353.073 242.48 351.91 238.172L289.566 7.16887C288.403 2.86109 283.965 0.305857 279.653 1.4616Z",
    fill: "#FFFAF0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_871_27318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.157 14.613L336.306 239.09L110.853 299.5L50.7041 75.0229L276.157 14.613ZM112.557 296.563L333.361 237.399L274.453 17.5499L53.6484 76.7144L112.557 296.563Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9327 70.575L131.461 292.738L129.137 293.361L69.6084 71.1978L71.9327 70.575Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5264 65.5928L150.055 287.756L147.731 288.379L88.2021 66.2156L90.5264 65.5928Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.121 60.6104L168.649 282.773L166.325 283.396L106.796 61.2332L109.121 60.6104Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.715 55.6282L187.243 277.791L184.919 278.414L125.391 56.251L127.715 55.6282Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.309 50.646L205.837 272.809L203.513 273.432L143.984 51.2688L146.309 50.646Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.903 45.6636L224.431 267.827L222.107 268.449L162.579 46.2864L164.903 45.6636Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.497 40.6814L243.025 262.844L240.701 263.467L181.173 41.3042L183.497 40.6814Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.091 35.6992L261.619 257.862L259.295 258.485L199.767 36.322L202.091 35.6992Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.685 30.7168L280.213 252.88L277.889 253.503L218.361 31.3396L220.685 30.7168Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.279 25.7346L298.808 247.898L296.483 248.52L236.955 26.3574L239.279 25.7346Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.873 20.7522L317.401 242.915L315.077 243.538L255.549 21.375L257.873 20.7522Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.576 35.7522L57.4468 95.5394L56.8267 93.2252L279.956 33.438L280.576 35.7522Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.537 54.2656L62.4077 114.053L61.7876 111.739L284.917 51.9514L285.537 54.2656Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.497 72.7793L67.3682 132.566L66.7481 130.252L289.877 70.4651L290.497 72.7793Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.458 91.293L72.3291 151.08L71.709 148.766L294.838 88.9788L295.458 91.293Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.418 109.806L77.2896 169.594L76.6695 167.279L299.798 107.492L300.418 109.806Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.379 128.32L82.2505 188.107L81.6304 185.793L304.759 126.006L305.379 128.32Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34 146.833L87.2114 206.621L86.5914 204.306L309.72 144.519L310.34 146.833Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.301 165.347L92.1719 225.134L91.5518 222.82L314.681 163.033L315.301 165.347Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.262 183.861L97.1328 243.648L96.5127 241.334L319.642 181.547L320.262 183.861Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.222 202.374L102.093 262.161L101.473 259.847L324.602 200.06L325.222 202.374Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.183 220.888L107.054 280.675L106.434 278.361L329.563 218.574L330.183 220.888Z",
    fill: "#FFEDA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.713 247.485L132.969 187.859C131.676 183.744 133.798 179.336 137.815 177.794L256.469 132.247C260.843 130.568 265.733 132.925 267.159 137.4L285.694 195.556C286.997 199.644 284.922 204.04 280.944 205.619L162.499 252.636C158.098 254.383 153.137 252.014 151.713 247.485Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_871_27318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.899 122.849L130.821 180.637L155.414 244.702L289.276 193.317L264.684 129.252L196.232 113.124C179.72 110.312 181.898 109.109 170.899 122.849Z",
    fill: "#DF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.057 100.16L127.969 143.954C126.289 144.599 125.451 146.487 126.098 148.172L157.124 228.997C157.77 230.682 159.657 231.525 161.337 230.88L275.424 187.085C277.105 186.44 277.943 184.552 277.296 182.868L246.27 102.042C245.623 100.357 243.737 99.5146 242.057 100.16Z",
    fill: "#FFFAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.612 125.298L160.128 145.061C159.97 145.121 159.8 145.062 159.749 144.93L159.413 144.055C159.362 143.922 159.449 143.764 159.607 143.704L211.091 123.941C211.248 123.881 211.419 123.939 211.47 124.072L211.806 124.947C211.857 125.08 211.769 125.237 211.612 125.298Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.443 135.237L163.959 154.999C163.802 155.06 163.631 155.001 163.58 154.869L163.244 153.993C163.193 153.861 163.281 153.703 163.439 153.643L214.922 133.88C215.08 133.819 215.251 133.878 215.302 134.01L215.638 134.886C215.688 135.018 215.601 135.176 215.443 135.237Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.049 177.41L164.88 202.426C164.702 202.494 164.51 202.428 164.453 202.279L164.14 201.464C164.083 201.315 164.181 201.137 164.359 201.069L229.528 176.053C229.705 175.985 229.897 176.051 229.954 176.2L230.267 177.015C230.324 177.164 230.226 177.342 230.049 177.41Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.211 188.266L169.042 213.282C168.864 213.35 168.672 213.284 168.615 213.135L168.302 212.319C168.245 212.171 168.343 211.993 168.521 211.925L233.69 186.909C233.867 186.841 234.059 186.907 234.117 187.056L234.43 187.871C234.487 188.02 234.388 188.198 234.211 188.266Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.218 173.213L166.95 207.864C166.773 207.932 166.581 207.866 166.524 207.717L166.211 206.902C166.154 206.753 166.252 206.575 166.429 206.507L256.697 171.856C256.875 171.788 257.067 171.854 257.124 172.003L257.437 172.819C257.494 172.968 257.396 173.145 257.218 173.213Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86 162.366L174.376 182.129C174.219 182.189 174.048 182.13 173.997 181.998L173.661 181.122C173.61 180.99 173.698 180.832 173.856 180.772L225.339 161.009C225.497 160.948 225.668 161.007 225.719 161.139L226.055 162.015C226.105 162.147 226.018 162.305 225.86 162.366Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.933 137.071L153.677 166.727C153.542 166.778 153.396 166.728 153.352 166.615L152.99 165.67C152.946 165.556 153.021 165.421 153.156 165.37L230.412 135.714C230.547 135.662 230.693 135.712 230.736 135.825L231.099 136.771C231.143 136.884 231.068 137.019 230.933 137.071Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.873 144.766L156.617 174.422C156.482 174.474 156.336 174.423 156.293 174.31L155.93 173.365C155.887 173.252 155.962 173.117 156.096 173.065L233.353 143.409C233.488 143.357 233.633 143.408 233.677 143.521L234.04 144.466C234.083 144.579 234.008 144.714 233.873 144.766Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.317 151.086L159.061 180.742C158.926 180.794 158.78 180.743 158.737 180.63L158.374 179.685C158.33 179.572 158.405 179.437 158.54 179.385L235.796 149.729C235.931 149.677 236.077 149.728 236.121 149.841L236.484 150.786C236.527 150.899 236.452 151.034 236.317 151.086Z",
    fill: "#FAF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.011 249.163L130.806 180.897L215.809 202.284L264.668 129.512L290.873 197.778L157.011 249.163Z",
    fill: "#FFBE55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.873 197.778L157.01 249.163L207.852 191.032C210.007 188.568 213.252 187.35 216.496 187.785L290.873 197.778Z",
    fill: "#FFCD7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.475 154.366C209.803 147.406 201.994 143.929 195.034 146.601C188.073 149.273 184.597 157.082 187.268 164.042C189.94 171.003 197.749 174.48 204.71 171.808L205.785 174.608C197.277 177.874 187.733 173.625 184.468 165.117C181.202 156.61 185.451 147.066 193.959 143.8C202.466 140.535 212.01 144.784 215.276 153.291C218.542 161.799 214.292 171.343 205.785 174.608L204.71 171.808C211.67 169.136 215.147 161.327 212.475 154.366Z",
    fill: "#B41517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.349 145.079L194.984 174.273L192.221 173.103L204.587 143.909L207.349 145.079Z",
    fill: "#B41517"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265.977 252.368C263.944 252.152 262.193 250.741 261.152 249.083C259.259 246.067 260.888 241.887 264.36 240.717C268.337 239.377 277.997 235.711 278.971 237.104C279.944 238.497 271.802 249.031 271.132 249.956C269.977 251.55 267.978 252.581 265.977 252.368Z",
    fill: "#162E4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.412 248.017C267.842 248.721 266.898 249.033 266.03 249.021C264.454 249 263.291 247.389 263.69 245.817C264.148 244.016 266.358 243.555 267.799 244.379C268.25 244.636 268.572 245.048 268.755 245.519C269.069 246.332 268.972 247.323 268.412 248.017Z",
    fill: "#7DB6F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M206.702 245.75C206.564 251.705 207.364 257.467 208.942 262.907L239.924 254.605C239.206 252.13 238.836 249.511 238.899 246.802C239.054 240.137 241.784 234.649 245.947 230.554L222.069 210.132C212.98 219.121 207.041 231.16 206.702 245.75Z",
    fill: "#E8615B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.423 214.262C308.145 205.004 299.173 197.732 288.181 194.405C287.32 194.145 286.452 193.909 285.581 193.686L275.145 223.221C275.419 223.295 275.694 223.362 275.965 223.445C280.966 224.958 285.047 228.266 287.903 232.478C289.599 234.98 290.851 237.803 291.617 240.755L322.613 232.45C320.928 225.96 318.151 219.761 314.423 214.262Z",
    fill: "#26BC96"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.071 210.132L245.949 230.554C253.268 223.356 265.032 220.491 275.147 223.22L285.583 193.685C263.478 188.036 237.959 194.418 222.071 210.132Z",
    fill: "#FFD106"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.276 209.883L221.838 210.394L245.715 230.816L246.153 230.305L222.276 209.883Z",
    fill: "#162E4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285.259 193.582L274.828 223.118L275.463 223.343L285.894 193.807L285.259 193.582Z",
    fill: "#162E4C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.773 252.689L203.808 263.934L203.982 264.585L245.948 253.341L245.773 252.689Z",
    fill: "#162E4C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M327.741 230.726L285.776 241.971L285.95 242.622L327.915 231.377L327.741 230.726Z",
    fill: "#162E4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_27318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 316,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_871_27318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 241,
    fill: "white",
    transform: "translate(45.0361 73.217) rotate(-15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_871_27318"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.276,
    y: 137.837,
    width: 143.386,
    height: 119.246,
    rx: 10,
    transform: "rotate(-21 114.276 137.837)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailblocking);
export default __webpack_public_path__ + "static/media/emailblocking.ca4ae7c67129a088a0bc23aea6d2dc39.svg";
export { ForwardRef as ReactComponent };